import React from 'react';
import PropTypes from 'prop-types';

import Input from '@Components/Input';
import AutosuggestDropdown from './AutosuggestInputDropdown';

export default class AutosuggestInput extends React.PureComponent {
  render() {
    const {
      idInput,
      classNameInput,
      groupBy,
      highlight,
      autofocus,
      inputProps,

      createdRef,
      dropdownDisplayed,
      matches,
      query,
      value,
      inputOnChange,
      autosuggestOnSelect,
      clearButton,
      afterLabelContent,
      animatedPlaceholder,
      placeholder,
      buildQuery,
      onClear,
      onSearch,
      closeDropdownAndResetMatches,
    } = this.props;

    const handleSearch = () => {
      if (onSearch) {
        onSearch();
        closeDropdownAndResetMatches();
      }
    };

    return (
      <div className="react-autosuggest-input" ref={createdRef}>
        {window.BUILD?.getAutosuggestValidation?.() && value && value.indexOf('aspirin') >= 0 ? (
          <div className="aspirin-police">
            <img alt="aspirin" src={window.BUILD?.getAutosuggestValidation?.()} />
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            <div>Say "aspirin" again!</div>
          </div>
        ) : null}
        <Input
          afterLabelContent={afterLabelContent}
          clearButton={clearButton}
          id={idInput}
          classNameInput={classNameInput}
          value={value}
          debounceDelay={0}
          onChange={inputOnChange}
          autofocus={autofocus}
          inputProps={{ ...inputProps, autoComplete: 'off' }}
          animatedPlaceholder={animatedPlaceholder}
          placeholder={placeholder}
          buildQuery={buildQuery}
          onClear={onClear}
          onApply={handleSearch}
        />
        {dropdownDisplayed && (
          <AutosuggestDropdown query={query} matches={matches} onSelect={autosuggestOnSelect} groupBy={groupBy} highlight={highlight} />
        )}
      </div>
    );
  }
}

AutosuggestInput.defaultProps = {
  animatedPlaceholder: false,
  clearButton: true,
  value: '',
  inputProps: {},
};

AutosuggestInput.propTypes = {
  /* owner props */
  buildQuery: PropTypes.object,
  idInput: PropTypes.string,
  classNameInput: PropTypes.string,
  groupBy: PropTypes.string,
  highlight: PropTypes.bool,
  autofocus: PropTypes.bool,

  /* withCreatedRef HOC */
  createdRef: PropTypes.object.isRequired,
  /* withAllStateHandlers HOC */
  dropdownDisplayed: PropTypes.bool,
  matches: PropTypes.array.isRequired,
  query: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /* withInputOnChange HOC */
  inputOnChange: PropTypes.func.isRequired,
  /* withAutosuggestOnSelect HOC */
  autosuggestOnSelect: PropTypes.func.isRequired,
  animatedPlaceholder: PropTypes.bool,
  clearButton: PropTypes.bool,
  afterLabelContent: PropTypes.element,
  placeholder: PropTypes.string,
  onClear: PropTypes.func,
  onSearch: PropTypes.func,
  closeDropdownAndResetMatches: PropTypes.func,
  inputProps: PropTypes.object,
};
